import React, { memo } from 'react';
import { Box, Text, useTheme } from '@ublend-npm/aulaui-core';
import { HOME_WIDGET_FONT_FAMILY } from '../homeWidgetTypography';
import { getSpaceWidgetColors } from './spaceWidgetColors';
import {
  SPACE_WIDGET_EMPTY_STATE_MIN_HEIGHT,
  SPACE_WIDGET_EMPTY_STATE_SUBTITLE,
  SPACE_WIDGET_EMPTY_STATE_TITLE,
} from './spaceWidgetConstants';

const SpaceWidgetEmptyState = () => {
  const { palette, shape } = useTheme();
  const colors = getSpaceWidgetColors(palette);
  const borderRadius = `${Number(shape.borderRadius) * 2}px`;

  return (
    <Box
      role="status"
      aria-label={SPACE_WIDGET_EMPTY_STATE_TITLE}
      sx={{
        width: '100%',
        minHeight: SPACE_WIDGET_EMPTY_STATE_MIN_HEIGHT,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        py: 2,
        px: 1,
        borderRadius,
        bgcolor: colors.emptyStateBg,
        fontFamily: HOME_WIDGET_FONT_FAMILY,
      }}
    >
      <Text
        sx={{
          m: 0,
          width: '100%',
          textAlign: 'center',
          fontFamily: HOME_WIDGET_FONT_FAMILY,
          fontSize: '1rem',
          fontWeight: 400,
          lineHeight: '175%',
          letterSpacing: '0.15px',
          color: colors.emptyStateTitle,
        }}
      >
        {SPACE_WIDGET_EMPTY_STATE_TITLE}
      </Text>
      <Text
        sx={{
          m: 0,
          pb: '5px',
          width: '100%',
          textAlign: 'center',
          fontFamily: HOME_WIDGET_FONT_FAMILY,
          fontSize: '0.875rem',
          fontWeight: 400,
          lineHeight: '150%',
          letterSpacing: '0.17px',
          color: colors.emptyStateSubtitle,
        }}
      >
        {SPACE_WIDGET_EMPTY_STATE_SUBTITLE}
      </Text>
    </Box>
  );
};

export default memo(SpaceWidgetEmptyState);
